<template>
  <div>
    <h1>{{ $t('errors.notFound.title') }}</h1>
    <p>{{ $t('errors.notFound.message') }}</p>
  </div>
</template>
